import { render } from "./ContestRules.vue?vue&type=template&id=628c5f12&scoped=true"
import script from "./ContestRules.vue?vue&type=script&lang=js"
export * from "./ContestRules.vue?vue&type=script&lang=js"

import "./ContestRules.vue?vue&type=style&index=0&id=628c5f12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628c5f12"]])

export default __exports__